module.exports = __webpack_public_path__ + "static/media/shenzhen-gray.14cbb7c5.svg";